
import '../theme/enterprise.css';
export default function DashboardLayout({ sidebar, topbar, children }) {
  return <div className="enterprise-shell" style={!sidebar ? { gridTemplateColumns: '1fr' } : undefined}>
    <a className="enterprise-skip" href="#enterprise-content">Skip to Enterprise content</a>
    {sidebar || null}<main>{topbar || null}<div id="enterprise-content" tabIndex={-1} className="enterprise-content">{children}</div></main>
  </div>;
}

